import { apiInternetBase, HttpType, openLoading } from 'gf-ui';

export class apiMalattieRare extends apiInternetBase {
  constructor(dispatch, apiCallback, token){
    super(dispatch, apiCallback, token, 'malattie-rare')
  }
  
  #malattieRare           = (cb) => this._getJson(HttpType.POST, `/categorie/malattie-rare`,        cb, this.token);  

  fnMalattieRare = (fnReturn, params, fnError) => {
    openLoading(this.dispatch)
    this.setParams(params);
    this.#malattieRare((status, res) => this.apiCallback(status, res, fnReturn, fnError))
  }
}